class CustomDropdown extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header');
    this.customDropdown = document.querySelectorAll('.custom-dropdown');
    this.addDropdownEvents();
  }

  addDropdownEvents() {
    this.customDropdown.forEach((dropdown) => {
      dropdown.addEventListener('mouseenter', () => {
        dropdown.setAttribute('open', '');
        this.header.classList.add('dropdown-open');
      });

      dropdown.addEventListener('mouseleave', () => {
        dropdown.removeAttribute('open');
        this.header.classList.remove('dropdown-open');
      });
    });
  }
}

customElements.define('custom-dropdown', CustomDropdown);
